import { AxiosError } from "axios";
import ChartLineView from "../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView";
import ChartLoaderView from "../../../../../common/components/molecule/Chart/ChartLoaderView/ChartLoaderView";
import { extractAxoisErrorsMessage } from "../../../../errorHandler/utils/errors.utils";
import { useConnectorEnergyConsumptionData } from "../../../hooks/StationAnalysis/useConnectorAnalysis";
import { createList } from "../../../../../common/analysis/utils/graph.utils";

export const ConnectorEnergyConsumptionChart = () => {
  const { energyConsumptionConnector, filter } =
    useConnectorEnergyConsumptionData();

  if (energyConsumptionConnector.isLoading) {
    return <ChartLoaderView />;
  }
  if (energyConsumptionConnector.isError && energyConsumptionConnector.error) {
    const error = energyConsumptionConnector.error as AxiosError;
    const message = extractAxoisErrorsMessage(error);
    if (message.includes("no data found")) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "gray",
          }}
        >
          <p>Aucune donnée trouvée</p>{" "}
        </div>
      );
    }
    return <div>Error occurred: {extractAxoisErrorsMessage(error)}</div>;
  }

  const dataChart = createList(
    filter.aggregateWindow || "1d",
    filter,
    energyConsumptionConnector.data || []
  );

  console.log("dataChart", dataChart.listValue);

  return (
    <ChartLineView
      xAxisData={dataChart.listx.map((item) => new Date(item))}
      data={dataChart.listValue.map((item) => Math.round(item * 0.001))}
      label="Energy Active (kWh)"
      unit="kwh"
    />
  );
};
